import React from "react";

const TankSwapDisclaimer = ({ expectedVolumeMet }) => {
  return (
    <div className="mt-1">
      <p>
        Please note, there may be an additional service fee on your tank repair
        or replacement request as you have requested off cycle maintenance or
        repair of your tank.
      </p>
      <div className="mb-1">
        <b>Our tank replacement and maintenance schedule</b>
      </div>
      <p>
        We have a fixed repair, maintenance and replacement schedule for tanks
        based on the volume of oil collected. That means that we replace or
        maintain the tank once we have done a number of collection cycles. If
        you require additional maintenance, we ask that you provide photos and
        detail to help us understand the maintenance required.
      </p>
      <div>Please confirm that you would like to request maintenance on your tank</div>
      {expectedVolumeMet && (
        <div>{`<<Because your repair/replacement request is within the maintenance cycle, you will not be charged for this request>>`}</div>
      )}
    </div>
  );
};
export default TankSwapDisclaimer;
